module.exports = __webpack_public_path__ + "img/sidebar.d2db2057.svg";